var watchlistList = {
	caption: "Meine Beobachtungsliste",
	name: "Name",
	numberOfPositions: "Stellen",
	actions: "Aktionen",
	createWatchlistAction: "Beobachtungsliste hinzufügen",
	editWatchlistAction: "Beobachtungsliste bearbeiten",
	deleteWatchlistAction: "Beobachtungsliste löschen",
	noWatchlist: {
		title: "Info",
		message: "Es wurde noch keine Beobachtungsliste erstellt. Bitte klicken Sie auf die Schaltfläche Beobachtungsliste hinzufügen und füllen Sie das Formular aus, um eine Beobachtungsliste zu erstellen"
	},
	showActions: "Aktionen anzeigen"
};
var de = {
	watchlistList: watchlistList
};

export { de as default, watchlistList };
